/* ===========================================================
   Harper Australia : tiroir panier, badge, barre d'ajout collante.
   Agent PANIER, migration Horizon (19/10/2026). Code Harper, sans dependance.
   Branchement Horizon :
   - un ajout depuis un formulaire Horizon (fiche, ajout rapide) est fait par Horizon ;
     on ouvre le tiroir tout de suite, on demande nos lignes dans la meme requete
     (champ `sections`) et on les applique a l'evenement `cart:update` ;
   - tout autre formulaire /cart/add est pris en charge ici (une seule requete) ;
   - chaque changement fait ici renvoie `cart:update` pour les composants d'Horizon.
   =========================================================== */
(function () {
  'use strict';

  var CFG = window.HFCART_CONFIG || {};
  var TIERS = (CFG.tiers || [{ qty: 2, pct: 10 }, { qty: 3, pct: 15 }, { qty: 4, pct: 20 }])
    .slice().sort(function (a, b) { return a.qty - b.qty; });
  var MONEY_FORMAT = String(CFG.moneyFormat || '${{amount}}').replace(/<[^>]+>/g, '').trim();
  var SP = CFG.shippingProtection || {};
  var SECTION = CFG.section || 'hz-panier-lignes';
  var SOURCE = 'hz-panier';
  var TIMER_TOTAL = 300; // 5 minutes

  var lastCart = CFG.cart || null;
  var timerInt = null;
  var chain = Promise.resolve();
  var inflight = 0;
  var loaderTimer = null;
  var pendingAdd = null;

  /* ---------- outils ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function el() { return document.getElementById('HFCartDrawer'); }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace(/[^0-9.-]/g, '');
    var n = Number(cents); if (isNaN(n)) n = 0;
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(num, p, t, d) {
      t = t || ','; d = d || '.';
      var parts = (num / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var m = MONEY_FORMAT.match(rx), key = m ? m[1] : 'amount', v;
    switch (key) {
      case 'amount_no_decimals': v = fmt(n, 0); break;
      case 'amount_with_comma_separator': v = fmt(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(n, 0, '.', ','); break;
      case 'amount_with_space_separator': v = fmt(n, 2, ' ', '.'); break;
      default: v = fmt(n, 2);
    }
    return MONEY_FORMAT.replace(rx, v);
  }
  function setBusy(state) {
    var d = el(); if (!d) return;
    if (state) {
      if (!loaderTimer) loaderTimer = setTimeout(function () { d.classList.add('is-busy'); }, 250);
    } else {
      if (loaderTimer) { clearTimeout(loaderTimer); loaderTimer = null; }
      d.classList.remove('is-busy');
    }
  }
  /* file d'attente : chaque changement passe l'un apres l'autre, aucun clic perdu ;
     une tache bloquee est liberee au bout de 14 s */
  function enqueue(task) {
    inflight++;
    setBusy(true);
    var run = function () {
      return new Promise(function (resolve) {
        var done = false;
        var finish = function () { if (!done) { done = true; resolve(); } };
        var guard = setTimeout(finish, 14000);
        Promise.resolve().then(task).then(
          function () { clearTimeout(guard); finish(); },
          function () { clearTimeout(guard); finish(); }
        );
      });
    };
    chain = chain.then(run, run).then(function () {
      inflight--;
      if (inflight <= 0) { inflight = 0; if (!pendingAdd) setBusy(false); }
    });
    return chain;
  }

  /* ---------- protection d'envoi ---------- */
  function isSP(variantId) { return String(variantId) === String(SP.variantId); }
  function spLineItem(cart) {
    if (!cart || !cart.items) return null;
    return cart.items.filter(function (i) { return isSP(i.variant_id); })[0] || null;
  }
  function spQty(cart) { var it = spLineItem(cart); return it ? it.quantity : 0; }
  function realCount(cart) { return Math.max(0, (cart.item_count || 0) - spQty(cart)); }

  /* ---------- API panier ---------- */
  function api(url, opts) {
    opts = opts || {};
    if (typeof AbortController !== 'undefined') {
      var ctrl = new AbortController();
      opts.signal = ctrl.signal;
      setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 10000);
    }
    opts.credentials = 'same-origin';
    return window.fetch(url, opts);
  }
  function jsonPost(url, body) {
    return api(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body || {})
    });
  }
  function unwrapSection(raw) {
    if (!raw) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = raw;
    var inner = tmp.querySelector('#shopify-section-' + SECTION);
    return inner ? inner.innerHTML : raw;
  }
  function sectionHTML(obj) { return unwrapSection(obj && obj.sections && obj.sections[SECTION]); }
  function parseCart(itemsHtml) {
    if (!itemsHtml) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = itemsHtml;
    var s = tmp.querySelector('[data-hf-cart]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }
  function refresh() {
    return enqueue(function () {
      return jsonPost('/cart/update.js', { sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { applyState(cart, sectionHTML(cart)); });
    });
  }
  /* previent les composants d'Horizon (quantite deja au panier, ajout rapide) */
  function announce(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { resource: cart, sourceId: SOURCE, data: { source: SOURCE, itemCount: cart ? cart.item_count : 0 } }
      }));
    } catch (e) {}
  }

  /* ---------- discussion Shopify Inbox masquee tant que le tiroir est ouvert ---------- */
  var CHAT_SEL = '#shopify-chat, shopify-chat, [id*="shopify-chat"], #chat-button-container, iframe[id*="chat"]';
  var chatObs = null;
  function hideChat() {
    $$(CHAT_SEL).forEach(function (n) { n.style.setProperty('display', 'none', 'important'); });
    if (window.tidioChatApi) window.tidioChatApi.hide();
  }
  function showChat() {
    $$(CHAT_SEL).forEach(function (n) { n.style.removeProperty('display'); });
    if (window.tidioChatApi) window.tidioChatApi.show();
  }
  function startChatWatch() {
    hideChat();
    if (chatObs) return;
    chatObs = new MutationObserver(function (muts) {
      if (!document.documentElement.classList.contains('hfcart-lock')) return;
      muts.forEach(function (m) {
        if (m.type === 'attributes') { hideChat(); }
        m.addedNodes.forEach(function (n) { if (n.nodeType === 1) hideChat(); });
      });
    });
    chatObs.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['style'] });
  }
  function stopChatWatch() { if (chatObs) { chatObs.disconnect(); chatObs = null; } }

  /* ---------- ouvrir / fermer ---------- */
  var lastFocus = null;
  function openDrawer() {
    var d = el(); if (!d) return;
    if (!d.classList.contains('is-open')) lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('hfcart-lock');
    startChatWatch();
    var btn = $('.hfcart__close', d);
    if (btn) { try { btn.focus({ preventScroll: true }); } catch (e) {} }
  }
  function open() { openDrawer(); refresh(); }
  function close() {
    var d = el(); if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('hfcart-lock');
    stopChatWatch();
    showChat();
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ---------- barre des paliers de remise ---------- */
  function buildBar() {
    var bar = $('[data-hfcart-bar]', el());
    if (!bar || bar.children.length) return;
    var n = TIERS.length;
    var html = '<div class="hfcart__bar-track"><div class="hfcart__bar-fill" data-hfcart-fill></div></div><div class="hfcart__nodes">';
    TIERS.forEach(function (t, i) {
      html += '<div class="hfcart__node" data-tier="' + i + '" style="left:' + ((i + 1) * (100 / n)) + '%">' +
                '<span class="hfcart__node-dot"></span><span class="hfcart__node-label">' + t.pct + '%</span></div>';
    });
    bar.innerHTML = html + '</div>';
  }
  function currentTier(c) { var r = null; TIERS.forEach(function (t) { if (c >= t.qty) r = t; }); return r; }
  function nextTier(c) { for (var i = 0; i < TIERS.length; i++) { if (c < TIERS[i].qty) return TIERS[i]; } return null; }
  function renderProgress(count) {
    var d = el();
    var fill = $('[data-hfcart-fill]', d), msg = $('[data-hfcart-msg]', d);
    var n = TIERS.length, maxQty = TIERS[n - 1].qty;
    var cur = currentTier(count), nxt = nextTier(count);
    var pct;
    if (count >= maxQty) { pct = 100; }
    else {
      var seg = 0, startQty = 0, endQty = TIERS[0].qty, prev = 0;
      for (var k = 0; k < n; k++) {
        if (count < TIERS[k].qty) { seg = k; startQty = prev; endQty = TIERS[k].qty; break; }
        prev = TIERS[k].qty;
      }
      var segW = 100 / n;
      pct = (seg * segW) + (((count - startQty) / (endQty - startQty)) * segW);
    }
    if (fill) fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
    var m = '';
    if (count > 0) {
      if (cur && nxt) {
        m = '<span class="hfcart__msg-win">' + cur.pct + '% off unlocked</span> &mdash; ' +
            'add <strong>' + (nxt.qty - count) + '</strong> more for <strong>' + nxt.pct + '% off</strong>';
      } else if (cur && !nxt) {
        m = '<span class="hfcart__msg-win">You’ve unlocked the maximum ' + cur.pct + '% off!</span>';
      } else if (nxt) {
        var need = nxt.qty - count;
        m = 'Add <strong>' + need + '</strong> more item' + (need > 1 ? 's' : '') +
            ' to unlock <strong>' + nxt.pct + '% off</strong>';
      }
    }
    if (msg) msg.innerHTML = m;
    $$('.hfcart__node', d).forEach(function (node, i) { node.classList.toggle('is-reached', count >= TIERS[i].qty); });
  }

  /* ---------- lignes de secours (si la section ne revient pas) ---------- */
  function itemHTML(item) {
    var img = sized(item.image, 200);
    var opts = (item.options_with_values || [])
      .filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return o.value; }).join(' / ');
    return '<div class="hfcart-item" data-key="' + escapeHtml(item.key) + '">' +
        '<a class="hfcart-item__img" href="' + escapeHtml(item.url) + '">' +
          (img ? '<img src="' + escapeHtml(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="hfcart-item__info">' +
          '<a class="hfcart-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' +
          (opts ? '<div class="hfcart-item__opts">' + escapeHtml(opts) + '</div>' : '') +
          '<div class="hfcart-item__price"><span class="hfcart-item__now">' + formatMoney(item.original_price) + '</span></div>' +
          '<div class="hfcart-item__qty">' +
            '<button type="button" class="hfcart-qty__btn" data-hfcart-minus aria-label="Decrease quantity">−</button>' +
            '<span class="hfcart-qty__val">' + item.quantity + '</span>' +
            '<button type="button" class="hfcart-qty__btn" data-hfcart-plus aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="hfcart-item__remove" data-hfcart-remove aria-label="Remove item">' +
          '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
      '</div>';
  }
  function fallbackItems(cart) {
    return cart.items.filter(function (i) { return !isSP(i.variant_id); }).map(itemHTML).join('');
  }

  /* « You'll love these » : 6 cartes au plus rendues en Liquid, les 3 premieres hors panier visibles */
  function refreshUpsell(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (i) { inCart[i.product_id] = true; });
    var shown = 0;
    $$('.hfups', el()).forEach(function (card) {
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      if (inCart[pid] || shown >= 3) { card.hidden = true; } else { card.hidden = false; shown++; }
    });
  }

  function syncProtectCheckbox(cart) {
    var box = $('[data-hfcart-protect]', el());
    if (box) box.checked = !!spLineItem(cart);
  }
  function toggleProtection(checked) {
    if (checked) { addToCart(SP.variantId, 1, null); }
    else {
      var it = spLineItem(lastCart);
      if (it) changeQty(it.key, 0); else syncProtectCheckbox(lastCart);
    }
  }

  /* ---------- minuterie de reservation ---------- */
  function store(fn) { try { return fn(); } catch (e) { return null; } }
  function timerTick() {
    var d = el(); if (!d) return;
    var raw = store(function () { return sessionStorage.getItem('hfcart_timer_start'); });
    if (!raw) { raw = String(Date.now()); store(function () { sessionStorage.setItem('hfcart_timer_start', raw); }); }
    var left = Math.max(0, TIMER_TOTAL - Math.floor((Date.now() - Number(raw)) / 1000));
    var mm = Math.floor(left / 60), ss = left % 60;
    var val = $('[data-hfcart-timer-val]', d);
    if (val) val.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
    if (left <= 0) {
      var strip = $('[data-hfcart-timer]', d);
      if (strip) strip.classList.add('is-expired');
      var txt = $('[data-hfcart-timer-text]', d);
      if (txt) txt.textContent = 'Hurry — your cart is about to expire!';
      if (timerInt) { clearInterval(timerInt); timerInt = null; }
    }
  }
  function timerEnsure() { if (timerInt) return; timerTick(); timerInt = setInterval(timerTick, 1000); }
  function timerReset() {
    store(function () { sessionStorage.removeItem('hfcart_timer_start'); });
    if (timerInt) { clearInterval(timerInt); timerInt = null; }
    var s = $('[data-hfcart-timer]', el());
    if (s) s.classList.remove('is-expired');
  }

  /* ---------- badge de l'en-tete ---------- */
  function badgeCount(cart) {
    if (!cart || !cart.items) return (cart && cart.item_count) || 0;
    var n = 0;
    cart.items.forEach(function (it) {
      var t = String(it.title || it.product_title || '').toLowerCase();
      if (t.indexOf('shipping protection') === -1 && t.indexOf('package protection') === -1 && t.indexOf('route') === -1) n += it.quantity || 0;
    });
    return n;
  }
  function ensureBadge() {
    var icon = $('[data-hh-cart-icon]');
    if (!icon) return null;
    var badge = $('[data-hz-panier-badge]', icon);
    if (!badge) {
      $$('[data-hz-panier-badge]').forEach(function (b) { b.remove(); });
      badge = document.createElement('span');
      badge.className = 'hz-panier-badge';
      badge.setAttribute('data-hz-panier-badge', '');
      badge.setAttribute('aria-hidden', 'true');
      icon.appendChild(badge);
    }
    return badge;
  }
  function updateBadge(count) {
    var badge = ensureBadge(); if (!badge) return;
    var label = count > 99 ? '99+' : String(count);
    var was = badge.textContent;
    if (count > 0) {
      badge.textContent = label;
      badge.classList.add('is-visible');
      badge.classList.toggle('is-wide', label.length > 1);
      if (was !== label) { badge.classList.remove('is-pop'); void badge.offsetWidth; badge.classList.add('is-pop'); }
    } else {
      badge.textContent = '';
      badge.classList.remove('is-visible', 'is-wide', 'is-pop');
    }
    var link = badge.closest('a');
    if (link) link.setAttribute('aria-label', count > 0 ? 'Cart, ' + count + ' item' + (count > 1 ? 's' : '') : 'Cart');
  }

  /* ---------- appliquer l'etat du panier ---------- */
  function applyState(cart, itemsHtml) {
    if (!cart) return;
    lastCart = cart;
    var d = el(); if (!d) return;
    var count = realCount(cart);

    /* itemsHtml : undefined = garder la liste rendue par le serveur ; texte = l'injecter ;
       null / '' = section absente, lignes de secours en JS */
    var itemsEl = $('[data-hfcart-items]', d);
    if (itemsEl && itemsHtml !== undefined) itemsEl.innerHTML = itemsHtml ? itemsHtml : fallbackItems(cart);

    var countEl = $('[data-hfcart-count]', d);
    if (countEl) countEl.textContent = count;

    var emptyEl = $('[data-hfcart-empty]', d), footEl = $('.hfcart__foot', d), progEl = $('[data-hfcart-progress]', d),
        timerEl = $('[data-hfcart-timer]', d), upsellEl = $('[data-hfcart-upsell]', d);
    if (count === 0) {
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.style.display = 'none';
      if (progEl) progEl.style.display = 'none';
      if (timerEl) timerEl.hidden = true;
      if (upsellEl) upsellEl.hidden = true;
      timerReset();
    } else {
      if (emptyEl) emptyEl.hidden = true;
      if (footEl) footEl.style.display = '';
      if (progEl) progEl.style.display = '';
      if (timerEl) timerEl.hidden = false;
      if (upsellEl) upsellEl.hidden = false;
      refreshUpsell(cart);
      timerEnsure();
    }
    renderProgress(count);

    /* economie sur prix barres : lue dans les lignes rendues en Liquid */
    var compareSavings = 0;
    var csEl = $('[data-hf-cart]', d);
    if (csEl) { try { compareSavings = (JSON.parse(csEl.textContent) || {}).compare_savings || 0; } catch (e) {} }
    var compareTotal = (cart.original_total_price || 0) + compareSavings;
    var totalSave = compareSavings + (cart.total_discount || 0);

    var orig = $('[data-hfcart-original]', d); if (orig) orig.textContent = formatMoney(compareTotal);
    var tot = $('[data-hfcart-total]', d); if (tot) tot.textContent = formatMoney(cart.total_price);
    var coT = $('[data-hfcart-checkout-total]', d); if (coT) coT.textContent = formatMoney(cart.total_price);
    var discRow = $('[data-hfcart-discount-row]', d), discEl = $('[data-hfcart-discount]', d);
    if (discRow && discEl) {
      if (totalSave > 0) { discRow.hidden = false; discEl.textContent = '−' + formatMoney(totalSave); }
      else { discRow.hidden = true; }
    }
    syncProtectCheckbox(cart);
    updateBadge(badgeCount(cart));
  }

  /* ---------- changements (tous en file) ---------- */
  function changeQty(key, qty) {
    enqueue(function () {
      return jsonPost('/cart/change.js', { id: key, quantity: qty, sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          applyState(cart, sectionHTML(cart));
          /* derniere vraie ligne retiree : la protection d'envoi orpheline part aussi */
          if (realCount(cart) === 0 && spQty(cart) > 0) {
            var sp = spLineItem(cart);
            if (sp && sp.key) {
              return jsonPost('/cart/change.js', { id: sp.key, quantity: 0, sections: SECTION, sections_url: '/cart' })
                .then(function (r2) { return r2.json(); })
                .then(function (cart2) { applyState(cart2, sectionHTML(cart2)); announce(cart2); });
            }
          }
          announce(cart);
        });
    });
  }
  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var label = btn ? btn.textContent : '';
    enqueue(function () {
      return jsonPost('/cart/add.js', { id: variantId, quantity: qty || 1, sections: SECTION, sections_url: '/cart' })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (btn) {
              var desc = (res.data && (res.data.description || res.data.message) || '').toLowerCase();
              btn.textContent = /stock|sold/.test(desc) ? 'Sold out' : 'Unavailable';
              setTimeout(function () { btn.textContent = label || 'Add'; }, 2200);
            }
            syncProtectCheckbox(lastCart);
            return;
          }
          if (btn) {
            btn.textContent = 'Added';
            setTimeout(function () { btn.textContent = label || 'Add'; }, 1500);
          }
          return afterAdd(res.data);
        });
    });
  }
  /* reponse d'ajout : la section porte l'etat du panier, une seule requete */
  function afterAdd(data) {
    var html = sectionHTML(data);
    var cart = parseCart(html);
    if (cart && html) { applyState(cart, html); announce(cart); return; }
    return jsonPost('/cart/update.js', { sections: SECTION, sections_url: '/cart' })
      .then(function (r) { return r.json(); })
      .then(function (c) { applyState(c, sectionHTML(c)); announce(c); });
  }
  /* formulaire /cart/add hors composant Horizon : ajout ici, tiroir ouvert tout de suite */
  function addFromForm(form) {
    openDrawer();
    var d = el(); if (d) d.classList.add('is-busy');
    enqueue(function () {
      var fd = new FormData(form);
      fd.append('sections', SECTION);
      fd.append('sections_url', '/cart');
      return api('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) { if (res.ok) return afterAdd(res.data); });
    });
  }

  /* ---------- ajout fait par Horizon (fiche, ajout rapide) ---------- */
  function endPending() {
    if (!pendingAdd) return;
    clearTimeout(pendingAdd.guard);
    if (pendingAdd.input && pendingAdd.input.parentNode) pendingAdd.input.parentNode.removeChild(pendingAdd.input);
    pendingAdd = null;
    if (inflight <= 0) setBusy(false);
  }
  function onHorizonSubmit(form) {
    openDrawer();
    var d = el(); if (d) d.classList.add('is-busy');
    endPending();
    var input = document.createElement('input');
    input.type = 'hidden'; input.name = 'sections'; input.value = SECTION;
    input.setAttribute('data-hz-panier-sections', '');
    form.appendChild(input);
    pendingAdd = { input: input, guard: setTimeout(function () { endPending(); refresh(); }, 9000) };
  }
  function onCartUpdate(e) {
    var det = (e && e.detail) || {};
    var data = det.data || {};
    if (data.source === SOURCE || det.sourceId === SOURCE) return;
    var html = data.sections ? unwrapSection(data.sections[SECTION]) : null;
    var fromForm = !!pendingAdd || /product-form/.test(String(data.source || ''));
    endPending();
    if (fromForm) openDrawer();
    var parsed = html ? parseCart(html) : null;
    if (parsed) {
      enqueue(function () { applyState(parsed, html); });
    } else {
      refresh();
    }
  }
  function onCartError() { if (pendingAdd) { endPending(); refresh(); } }

  /* ---------- evenements delegues ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-hfcart-close]')) { close(); return; }
    if (t.closest('[data-hfcart-checkout]')) { window.location.href = '/checkout'; return; }
    var itemEl = t.closest('.hfcart-item');
    if (itemEl && el() && el().contains(itemEl)) {
      var key = itemEl.getAttribute('data-key');
      var item = lastCart && lastCart.items && lastCart.items.filter(function (i) { return i.key === key; })[0];
      var q = item ? item.quantity : 1;
      if (t.closest('[data-hfcart-plus]'))   { changeQty(key, q + 1); return; }
      if (t.closest('[data-hfcart-minus]'))  { changeQty(key, Math.max(0, q - 1)); return; }
      if (t.closest('[data-hfcart-remove]')) { changeQty(key, 0); return; }
    }
    var addBtn = t.closest('[data-hfups-add]');
    if (addBtn && !addBtn.disabled) { addToCart(addBtn.getAttribute('data-variant-id'), 1, addBtn); }
  }
  function onChange(e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('[data-hfups-variant]')) {
      var card = t.closest('.hfups');
      var btn = card && card.querySelector('[data-hfups-add]');
      if (btn) {
        btn.setAttribute('data-variant-id', t.value);
        if (btn.disabled) { btn.disabled = false; btn.textContent = 'Add'; }
      }
      return;
    }
    if (t.matches('[data-hfcart-protect]')) toggleProtection(t.checked);
  }
  function onDocClickCapture(e) {
    var a = e.target.closest && e.target.closest('[data-hfcart-open], a[href$="/cart"], a[href$="/cart/"]');
    if (!a || (el() && el().contains(a))) return;
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }
  function onSubmitCapture(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (form.closest('product-form-component')) { onHorizonSubmit(form); return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    addFromForm(form);
  }

  /* ---------- barre d'ajout collante (fiche produit, mobile) ---------- */
  function initSticky() {
    var sticky = document.getElementById('hpStickyATC');
    if (!sticky) return;
    function mainForm() {
      return $('main product-form-component form[action*="/cart/add"]') || $('form[action*="/cart/add"]');
    }
    function mainBtn() { var f = mainForm(); return f && f.querySelector('[type="submit"]'); }
    function check() {
      var b = mainBtn();
      var show = !!b && b.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    var raf = null;
    function onScroll() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; check(); }); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check(); setTimeout(check, 500); setTimeout(check, 1500);
    var btn = document.getElementById('hpStickyBtn');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      var b = mainBtn(), f = mainForm();
      if (b && !b.disabled) { b.click(); }
      else if (f && f.requestSubmit) { f.requestSubmit(); }
    });
  }

  /* ---------- fiches vues (pour « Recently viewed » de la page panier) ---------- */
  function rememberProduct() {
    var p = CFG.product;
    if (!p || !p.h) return;
    store(function () {
      var list = JSON.parse(localStorage.getItem('hz-recent') || 'null');
      if (!Array.isArray(list)) {
        list = [];
        /* reprise de la memoire de l'ancien site : poignee, adresse, image */
        var old = JSON.parse(localStorage.getItem('theme-recent') || 'null');
        if (old && typeof old === 'object') {
          Object.keys(old).reverse().forEach(function (h) {
            var o = old[h] || {};
            list.push({ h: h, u: o.url || ('/products/' + h), t: null, i: o.featuredImage ? String(o.featuredImage).replace('_{width}x', '') : null });
          });
        }
      }
      list = list.filter(function (x) { return x && x.h && x.h !== p.h; });
      list.unshift({ h: p.h, u: p.u, t: p.t, i: p.i });
      localStorage.setItem('hz-recent', JSON.stringify(list.slice(0, 12)));
    });
  }

  /* ---------- demarrage ---------- */
  function init() {
    if (!el()) return;
    buildBar();
    applyState(CFG.cart);
    document.addEventListener('click', onClick);
    document.addEventListener('change', onChange);
    /* sur window, en capture : passe avant les ecouteurs d'Horizon (capture sur document) */
    window.addEventListener('click', onDocClickCapture, true);
    window.addEventListener('submit', onSubmitCapture, true);
    document.addEventListener('cart:update', onCartUpdate);
    document.addEventListener('cart:error', onCartError);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) close(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
    initSticky();
    rememberProduct();
  }
  window.HFCart = { open: open, close: close, refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
